import { CheckboxProps as CheckboxPropsMui, InputProps } from '@mui/material';
import {
  StyledContainer,
  StyledCheckboxRoot,
  StyledIconUnchecked,
  StyledIconChecked,
  LabelText,
} from './Checkbox.styles';

export interface CheckboxProps extends CheckboxPropsMui {
  label?: React.ReactNode;
  labelPlacement?: 'start' | 'top' | 'bottom' | 'end';
  error?: boolean;
  inputProps?: InputProps['inputProps'];
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  labelPlacement = 'end',
  error = false,
  ...restProps
}): JSX.Element => {
  return (
    <StyledContainer
      label={
        <LabelText variant='h6' fontWeight='fontWeightMedium'>
          {label}
        </LabelText>
      }
      labelPlacement={labelPlacement}
      control={
        <StyledCheckboxRoot
          error={error}
          icon={
            <StyledIconUnchecked
              className='iconUnchecked'
              data-testid='unchecked-icon'
            />
          }
          checkedIcon={<StyledIconChecked data-testid='checked-icon' />}
          {...restProps}
        />
      }
    />
  );
};

export default Checkbox;
